<template>
    <div v-show="!hidden" class="selectbar-menu"
         @wheel.stop 
         @mouseenter="$emit('diableMapDragAndZoom')"
         @mouseleave="$emit('enableMapDragAndZoom')"
         >
      <div class="title-bar"  @mousedown="startDrag">
        <span>选择要统计展示项</span> 
        <div class="close-button" @click="$emit('closeSelectMenu')">×</div>
      </div>
      <!-- 显示统计信息 -->
      <div class="content-container" v-show="searchOption">
        <div class="listbox-container">
            <p>属性列表</p>            
            <p>属性值</p>
        </div>
        <div class="listbox-container">
            <!-- 左侧 listbox -->
            <select class="left-listbox" multiple @change="selectKey">
                <!-- 这里可以动态添加选项 -->
                <option v-for="column in searchOption.columns" :key="column.name" :value="column.name">{{column.name}}({{column.label}})</option>                
            </select>
            <div>
                <button @click="getOnlyValuesByKey(TCMC)">获取唯一值</button>                
            </div>
            <!-- 右侧 listbox -->
            <select class="right-listbox" multiple @change="selectValue">
                <!-- 这里可以动态添加选项 -->
                <option v-for="value in onlyValues" :key="value" :value="value">{{value}}</option>
            </select>
        </div>
        <div class="listbox-container">
            <div class="button-container">
              <button @click="insertKey(selectedKey)">添加键值</button> 
            </div>            
            <div class="button-container">
              <button @click="insertWords('&&')">&&(并且)</button>  
              <button  @click="insertWords('||')">||(或)</button>   
              <button  @click="insertWords('==')">==(等于)</button>   
              <button  @click="insertWords('!=')">!=(不等于)</button> 
              <button  @click="insertWords(`[].includes(item.${selectedKey})`)">includes(包含)</button> 
              <button  @click="insertWords(`![].includes(item.${selectedKey})`)">!includes(不包含)</button>
            </div> 
            <div class="button-container">
              <button  @click="insertValue(selectedValue)">添加属性值</button>
            </div>            
        </div>
        <div class="listbox-container">
            <p>查询语句</p>
            <textarea v-model="sqlText" rows="5" style="flex:1"  @mousedown="preventEvent" @mousemove="preventEvent"></textarea>
        </div>
        <div class="listbox-container">
          <div class="button-container">
            <button @click="selectPatchesByConditionCallback">查询</button> 
          </div> 
          <div class="button-container">
            <p>查询结果：<span>{{resultMsg}}</span></p>
          </div>  
          <div class="button-container">
            <button @click="$emit('setStatPatches',TCMC)">应用至当前统计依据</button> 
          </div> 
            
        </div>
      </div>      
    </div>    
  </template>
  
  <script>
 


  export default {
    name: 'StatisticalSelect',
    props:{      
      hidden:{
          type:Boolean,
          default:false,
      },
      searchOption:{
        type:Object,
        default:null,
      },
      TCMC:{
        type:String,
        default:'',
      },
    },
    data() {
      return {
        isDragging: false,
        startX: 0,
        startY: 0,
        offsetX: 0,
        offsetY: 0,  
        onlyValues:[],
        selectedKey:'',
        selectedValue:'',  
        sqlText:'',   
        resultMsg:'未开始', 
      };
    },
    
    methods: {
      updateComponent(){  //更新组件 
          this.$forceUpdate();
      },
      
      startDrag(event) {
        event.stopPropagation(); // 阻止事件冒泡        
        event.preventDefault(); // 阻止默认行为
        this.isDragging = true;
        this.startX = event.clientX;
        this.startY = event.clientY;
        this.offsetX = this.$el.offsetLeft;
        this.offsetY = this.$el.offsetTop;
        document.addEventListener('mousemove', this.drag);
        document.addEventListener('mouseup', this.stopDrag);
      },
      drag(event) {
        event.stopPropagation(); // 阻止事件冒泡
        if (this.isDragging) {
          const dx = event.clientX - this.startX;
          const dy = event.clientY - this.startY;
          this.$el.style.left = `${this.offsetX + dx}px`;
          this.$el.style.top = `${this.offsetY + dy}px`;
        }
      },
      stopDrag() {
        this.isDragging = false;
        document.removeEventListener('mousemove', this.drag);
        document.removeEventListener('mouseup', this.stopDrag);
      }, 
      clickTJButton(btnIndex,code,cvalue,bz){  //点击按钮
        this.$emit("clickTJZSButton",{btnIndex,code,cvalue,bz});
      },

      selectKey(event){
        this.selectedKey = event.target.value;
      },

      selectValue(event){
        this.selectedValue = event.target.value;
      },

      getOnlyValuesByKey(TCMC){                 
        this.$emit('getOnlyValuesByKeyCallback',{TCMC:TCMC,key:this.selectedKey},(values)=>{
          this.onlyValues = values;
        });        
      },
      insertKey(words){
        this.sqlText += ` item.${words}`;      
      },
      insertValue(words){
        if(!isNaN(parseFloat(words)) && isFinite(words)){
          this.sqlText += ` ${words} `;
        }else{
          this.sqlText += ` '${words}' `;
        }
      },
      insertWords(words){
        this.sqlText += ` ${words} `;
      },

      selectPatchesByConditionCallback(){
        if(this.sqlText == ''){
          this.resultMsg = '查询语句不能为空';
          return;
        }
        let params= {TCMC:this.TCMC,condition:this.sqlText};
        this.$emit('selectPatchesByConditionCallback',params,(msg)=>{
          this.resultMsg = msg.msg;
        })
      },

      // 新增方法，用于阻止事件冒泡和默认行为
      preventEvent(event) {
            event.stopPropagation();
        }
    }
  };
  </script>
  
  <style scoped>
  .selectbar-menu {
    position: fixed;
    top: 15vh;
    left:460px;
    width: 50vw; /* 可以根据需要调整宽度 */
    
    background-color: #f0f0f0; /* 可以根据需要调整背景颜色 */
    padding: 5px;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1); /* 添加阴影效果 */
    z-index: 1001;
    text-align: left;
    overflow: hidden;
  }
  
  .title-bar {
    background-color: #e0e0e0; /* 标题栏背景颜色 */
    padding: 5px;
    margin: -10px -10px 10px -10px; /* 调整标题栏的边距 */
    display: flex;
    justify-content: space-between;
    align-items: center;
    position:sticky;
    padding-left: 10px;
    top:0;
  }
  
  .content-container {
    height: calc(100% - 30px); /* 减去标题栏高度 */
    overflow-y: auto; /* 添加垂直滚动条 */
  }

  .close-button {
    position: absolute;
    top: 2px;
    right: 10px;
    font-size: 20px;
    cursor: pointer;
  }
  
  .info-title {
    background-color: #d0d0d0; /* 标题背景色 */
    padding: 2px;
    cursor: pointer;
    width: 120px;
    font-size: 16px;
    text-align: center;    
  }
  
  .info-content {
    background-color: #e8e8e8; /* 内容背景色 */
    padding-left: 0.1em; /* 内容开头空两格 */
  }
  
  .info-strong{
      font-weight: bold;
  }
  .indented-content {
    padding-left: 2em; /* 缩进 2 个空格 */
  }
  
  .info-clickable{
      cursor: pointer;
  }

  .listbox-container {
    display: flex;
    justify-content: space-between;
    margin: 5px;
  }

  /* 左侧 listbox 样式 */
  .left-listbox {
      width: 40%; /* 可以根据需要调整宽度 */
      height:200px;
  }

  /* 右侧 listbox 样式 */
  .right-listbox {
      width: 40%; /* 可以根据需要调整宽度 */
      height:200px;
  }

  .button-container {
    display: flex;
    flex-direction: row;    
    align-items: flex-start;
    gap: 5px; /* 按钮之间的间距 */
    margin-top: 2px; /* 按钮与上方内容的间距 */
    /* border-bottom: 1px solid #909fb0; */
    padding-bottom: 5px;
    padding-top:5px;
 }

 .button-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 5px; /* 按钮之间的间距 */
    width: calc(100% - 125px); /* 减去 span 的宽度和间距 */
 }

 .button-container button {
    /* 设置按钮的固定宽度 */
    height: 30px; /* 设置按钮的固定高度 */
    /* 可以根据需要调整按钮的其他样式，如字体大小、边框等 */
    font-size: 14px;
    /* border: 1px solid #ccc; */
    border-radius: 4px;
    cursor: pointer;
 }
 /* 鼠标悬停时的样式 */
 .button-container button:hover {
    background-color: #9b9fa3; /* 悬停时的背景颜色 */
    color: #fff; /* 悬停时的文字颜色 */
    border-color: #007bff; /* 悬停时的边框颜色 */
 }

 .button-container button.active {
    background-color: #007bff; /* 选中时的背景颜色 */
    color: #fff; /* 选中时的文字颜色 */
    border-color: #007bff; /* 选中时的边框颜色 */
}
  </style>
  